import React, { useState } from "react"

const CopyEmailButton = ({ email }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <button
      onClick={handleCopy}
      title="Kopeeri e-posti aadress"
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "0 4px",
        fontSize: "0.9em",
        verticalAlign: "middle",
        opacity: copied ? 1 : 0.6,
      }}
      aria-label="Kopeeri e-posti aadress"
    >
      {copied ? "✓" : "⎘"}
    </button>
  )
}

export default CopyEmailButton
